import { Itinerary, Leg } from "~/api/resources/Itineraries";
import { MapList } from "../MapList";
import { LegCard } from "./LegCard";
import { MapStopCard } from "../../Cards";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { ArrowLeft, PinSolid } from "~/images/svgs";
import pluralize from "pluralize";
import { useSliderContext } from "../../Slider";
import { useLegContext } from "./LegProvider";
import { EastToWestToggle } from "./EastWestToggle";

export const ItineraryList = ({ legs }: Pick<Itinerary, "legs">) => {
  const legsWithStops = legs.filter((l) => l.stops.length > 0);
  const { isEast, legIndex } = useLegContext();
  const directedLegs = isEast ? legsWithStops : [...legsWithStops].reverse();
  if (legIndex === null) return <LegList legs={directedLegs} />;
  return <StopList leg={directedLegs[legIndex]} />;
};

type StopListProps = {
  leg: Leg;
};

const StopList = ({ leg }: StopListProps) => {
  const { legIndex, setLegIndex } = useLegContext();
  const { setActiveIndex } = useSliderContext();
  if (!leg) return null;
  const { stops } = leg;

  return (
    <MapList
      before={
        <Flex
          slot="container-start"
          bgColor="white"
          zIndex={2}
          pos="relative"
          p={8}
          pb={4}
          borderTopRadius="3xl"
          gap={3}
        >
          <Box>
            <ArrowLeft
              boxSize="24px"
              onClick={() => {
                setActiveIndex(legIndex || 0);
                setLegIndex(null);
              }}
              cursor="pointer"
              mb={4}
            />
            <Heading
              fontSize={{ base: "xl" }}
              fontWeight={{ base: 400 }}
              mb="8px"
            >
              {leg.title}
            </Heading>
            <Flex gap={2} alignItems="center">
              <PinSolid boxSize="11px" mt="2px" />
              <Text fontSize={{ base: "md" }}>
                {pluralize("stop", stops.length, true)}
              </Text>
            </Flex>
          </Box>
        </Flex>
      }
      wrapper_props={{ maxW: { base: "90vw", lg: 480 }, gap: 0 }}
    >
      {stops.map((stop, i) => {
        return <MapStopCard key={stop.id} stop={stop} />;
      })}
    </MapList>
  );
};

type LegListProps = {
  legs: Leg[];
};
const LegList = ({ legs }: LegListProps) => {
  const { setLegIndex } = useLegContext();
  const { setActiveIndex } = useSliderContext();
  let noOfLegs = legs.length - 1;
  return (
    <MapList
      before={<EastToWestToggle boxShadow={"md"} slot="container-start" />}
      wrapper_props={{ maxW: { base: "90vw", md: 380, lg: 480 }, gap: 4 }}
    >
      {legs.map((leg, i) => {
        return (
          <LegCard
            key={leg.id}
            leg={leg}
            isLast={noOfLegs === i}
            onClick={() => {
              setActiveIndex(0);
              setLegIndex(i);
            }}
          />
        );
      })}
      <Box mb={5} />
    </MapList>
  );
};
